import { render, staticRenderFns } from "./PackingTable.vue?vue&type=template&id=9cdab48a&scoped=true&"
import script from "./PackingTable.vue?vue&type=script&lang=js&"
export * from "./PackingTable.vue?vue&type=script&lang=js&"
import style0 from "./PackingTable.vue?vue&type=style&index=0&id=9cdab48a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdab48a",
  null
  
)

export default component.exports